import React, { ReactNode } from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import {
  getBugsnagApiKey,
  getGatsbyEnv,
} from "../../utilities/environment-variables";

Bugsnag.start({
  apiKey: getBugsnagApiKey(),
  enabledReleaseStages: ["production", "staging"],
  plugins: [new BugsnagPluginReact()],
  releaseStage: getGatsbyEnv(),
});

const plugin = Bugsnag.getPlugin("react");
if (plugin == null) {
  throw Error("The Bugsnag React plugin cannot be null.");
}
const ErrorBoundary = plugin.createErrorBoundary(
  /*
  For some reason, the React type expected by `createErrorBoundary` is not the
  same as the React type that we have. As a workaround, we can tell TypeScript
  that React's type is undefined because that's an acceptable input type for
  `createErrorBoundary`. Hopefully these types will get fixed and we can remove
  all uses of the `as` keyword in the line below.
  */
  React as unknown as undefined
);

if (ErrorBoundary == null) {
  throw Error("ErrorBoundary must be present.");
}

export function BugsnagErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
